import { render, staticRenderFns } from "./_old_ResalesWaitingReview.vue?vue&type=template&id=32acddcc"
import script from "./_old_ResalesWaitingReview.vue?vue&type=script&lang=js"
export * from "./_old_ResalesWaitingReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports